export const loadFont = async (family: string, url: string) => {
    const fontFile = new FontFace(family, `url(${url})`);
    document.fonts.add(fontFile);
    document.body.style.fontFamily = "Sans Serif";
    return fontFile.load();
};

export const getFontBase64 = async (url: string) =>
    new Promise<string>(async (resolve) => {
        const axios = (await import("axios")).default;
        const { data } = await axios.get<ArrayBuffer>(url, { responseType: "arraybuffer" });
        const blob = new Blob([data]);
        const reader = new FileReader();
        reader.onload = (event) => {
            const dataUrl = event.target?.result;
            resolve(dataUrl?.toString() || "");
        };
        reader.onerror = () => {
            resolve("");
        };
        reader.readAsDataURL(blob);
    });

export const attachCorrectDataHeaderToB64 = (text: string) =>
    text
        .split(",")
        .map((chunk, index) => (index === 0 ? "data:font/truetype;charset=utf-8;base64" : chunk))
        .join();
